import React, {useState} from 'react';
import {useNavigate} from "react-router-dom";
import {Button, Card, Col, Form, Image, Input, message, Row} from "antd";
import {UserOutlined, UnlockOutlined} from "@ant-design/icons";

import Logo from "../../../assets/octoopi_logo.png";
import Title from "../../../components/Title";
import {useResetPasswordMutation} from "../../../slices/rootApiSlices/authApiSlice";

const Index = () => {


    const navigate = useNavigate()
    const [email, setEmail] = useState("");
    const [resetHandle, {isLoading}] = useResetPasswordMutation()

    const onFinish = async () => {
        try {
            const res = await resetHandle({email: email}).unwrap();
            setEmail("")
            navigate('/auth/sign-in')
            message.success(res?.messageTR, 4)
        } catch (e) {
            setEmail("")
            message.error(e?.data?.messageTR, 4)
        }
    }

    return (
        <Row gutter={16}>
            <Col>
                <Card style={{width: 440, height: 340}}>
                    <div style={{textAlign: "center"}}>
                        <Title title="Octoopi Twin | Şifremi Unuttum" description="Octoopi Twin Reset Password"/>
                        <Image src={Logo} preview={false} width="70px" height="70px"/>
                        <h2>Octoopi Twin Cocpit</h2>
                        <h3>Şifremi Unuttum</h3>
                        <p><strong>Lütfen kayıtlı olduğunuz e-posta adresinizi giriniz.</strong></p>
                    </div>
                    <Form
                        name="normal_login"
                        className="login-form"
                        initialValues={{
                            remember: true,
                        }}
                        onFinish={onFinish}
                    >
                        <Form.Item
                            name="username"
                            rules={[
                                {
                                    type: "email",
                                    required: true,
                                    message: 'lütfen düzgün bir e-posta adresi giriniz !',
                                },
                            ]}
                        >
                            <Input
                                size="large"
                                prefix={<UserOutlined className="site-form-item-icon"/>}
                                placeholder="E-posta"
                                disabled={isLoading}
                                autoComplete="email"
                                name="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button
                                size="large"
                                style={{marginBottom: 1, fontSize: 15, fontWeight: 500}}
                                type="primary"
                                htmlType="submit"
                                className="login-form-button"
                                block
                                icon={<UnlockOutlined/>}
                                disabled={isLoading || !email}
                            >
                                Şifremi Sıfırla
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </Col>
        </Row>
    );
};

export default Index;
